export default __webpack_public_path__ + "static/media/09_photo.4c138a0a.jpg";